import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Injector,
    OnDestroy,
    OnInit
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { EditPanelComponent } from '@Work/Accounts/proprietary/controls/form-controls/edit-panel/edit-panel.component';
import { DocumentDistributeObjectService } from '@Core/models/proprietary/document-distribute/document-distribute-object.service';
import { DocumentDistributeObjectState } from '@Core/models/proprietary/document-distribute/document-distribute-object.state';

@Component({
    standalone: false,
    selector: 'ep-document-distribute-correspond-options-edit-panel',
    templateUrl: './document-distribute-correspond-options-edit-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentDistributeCorrespondOptionsEditPanelComponent
    extends EditPanelComponent
    implements OnInit, AfterViewInit, OnDestroy {
    @Select(DocumentDistributeObjectState.correspondTemplates)
    correspondTemplates$: Observable<[]>;

    @Select(DocumentDistributeObjectState.correspondOptions)
    correspondOptions$: Observable<any>;
    correspondOptionsSub: Subscription;

    constructor(
        private injector: Injector,
        private cdRef: ChangeDetectorRef,
        public documentDistributeOS: DocumentDistributeObjectService
    ) {
        super(injector);

        this.form = new UntypedFormGroup(
            {
                CorrespondOptions: this.fb.group({
                    CorrespondOptions_ID: [''],
                    Cover_Memo_Object_Code: [''],
                    Message: [''],
                    Subject: [''],
                    Delivery_Method: ['']
                })
            },
            { updateOn: 'blur' }
        );
    }

    ngOnInit() {
        this.ignorePageState = true;

        super.ngOnInit();

        this.formChangeSub = this.form.valueChanges.subscribe((value) => {
            this.documentDistributeOS.updateCorrespondOptions(this.form.getRawValue().CorrespondOptions);
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.correspondOptionsSub = this.correspondOptions$.subscribe((data) => {
                if (data) {
                    this.setFormData(data);
                }
            });
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    applyRules() {
        const coverMemo = this.form.getRawValue().CorrespondOptions.Cover_Memo_Object_Code;
        this.disableControl('CorrespondOptions.Subject', coverMemo != '');
        this.disableControl('CorrespondOptions.Message', coverMemo != '');
    }

    setFormData(value: any) {
        if (value) {
            this.form.controls.CorrespondOptions.patchValue(value, { emitEvent: false });
            this.cdRef.detectChanges();
            this.applyRules();
        }
    }
}
